var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShiftleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42431 3.22678C9.78434 1.70817 12.5463 0.933897 15.3518 1.00442C18.1573 1.07495 20.8769 1.98702 23.1577 3.62228C25.4384 5.25755 27.1751 7.54053 28.1423 10.175C29.1095 12.8095 29.2626 15.6738 28.5818 18.3964M22.5757 26.7732C20.2157 28.2918 17.4537 29.0661 14.6482 28.9956C11.8427 28.9251 9.12309 28.013 6.84234 26.3777C4.56159 24.7425 2.82494 22.4595 1.85773 19.825C0.890521 17.1905 0.737397 14.3262 1.41823 11.6036M9 15H21M9 15L13 11M9 15L13 19M8 5C8 6.65686 6.65686 8 5 8C3.34315 8 2 6.65686 2 5C2 3.34315 3.34315 2 5 2C6.65686 2 8 3.34315 8 5ZM28 25C28 26.6569 26.6569 28 25 28C23.3431 28 22 26.6569 22 25C22 23.3431 23.3431 22 25 22C26.6569 22 28 23.3431 28 25Z",
    stroke: "#0D2144",
    strokeOpacity: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftleft);
export default __webpack_public_path__ + "static/media/shiftleft.467654c345e50aaa7b74a5426146ced2.svg";
export { ForwardRef as ReactComponent };